import React from "react";
import { RescheduleItem, RescheduleItemType } from "@myapp/contract";
import { formatDateDDMMYYYY } from "../../../../shared/helpers/date";
import { ListItem } from "../../../../shared/ui/list/ListIteam/ListItem";
import { rescheduleColumns } from "../model/constants";
import { getRescheduleTypeLabel, getRescheduleTypeColor } from "../../../../entities/reschedule";
import { RescheduleReason } from "./RescheduleReason";
import { routes } from "../../../../shared/config/routes";

interface Props {
  item: RescheduleItem;
}

function getItemLink(item: RescheduleItem): string | undefined {
  if (item.type === "APPOINTMENT") {
    const meta = item.entityMeta as { workOrderId: string };
    return routes.task.detail(meta.workOrderId);
  }
  if (item.type === "TASK") {
    return routes.aufgaben.edit(item.id);
  }
  return undefined;
}

const TypeBadge: React.FC<{ type: RescheduleItemType }> = ({ type }) => (
  <span
    className="inline-flex items-center rounded-full px-2 py-0.5 font-['Roboto'] text-[11px] font-medium text-white"
    style={{ backgroundColor: getRescheduleTypeColor(type) }}
  >
    {getRescheduleTypeLabel(type)}
  </span>
);

export const RescheduleListItem: React.FC<Props> = ({ item }) => {
  const link = getItemLink(item);
  const date = item.scheduledDate ? formatDateDDMMYYYY(item.scheduledDate) : "-";

  return (
    <>
      {/* Mobile card (<768px) */}
      <div className="md:hidden">
        <a
          href={link ?? "#"}
          className="block w-full rounded-2xl bg-white px-4 py-3 active:opacity-80"
        >
          <div className="flex items-center justify-between gap-2">
            <TypeBadge type={item.type} />
            <span className="font-['Roboto'] text-[12px] tabular-nums text-gray-600">{date}</span>
          </div>
          <p className="mt-1 font-['Roboto'] text-[14px] font-bold text-gray-800 leading-tight">
            {item.title}
          </p>
          {item.technicianName && (
            <p className="mt-0.5 font-['Roboto'] text-[12px] text-gray-600">{item.technicianName}</p>
          )}
          <RescheduleReason item={item} className="mt-2" />
        </a>
      </div>

      {/* Desktop row (>=768px) */}
      <div className="hidden md:block w-full">
        <ListItem columns={rescheduleColumns} link={link}>
          <ListItem.Cell>
            <TypeBadge type={item.type} />
          </ListItem.Cell>
          <ListItem.Cell>{item.title}</ListItem.Cell>
          <ListItem.Cell>{item.technicianName ?? "-"}</ListItem.Cell>
          <ListItem.Cell className="tabular-nums">{date}</ListItem.Cell>
          <ListItem.Cell>
            <RescheduleReason item={item} />
          </ListItem.Cell>
        </ListItem>
      </div>
    </>
  );
};
